export default "import React from 'react';\n\nexport default () => (\n  <div className=\"MyComponent\">\n    <h1>Hello world!</h1>\n  </div>\n);\n";